import React from 'react';
import { CardTitle, Card, CardContent, Input, withGrid, Textarea } from '../../../Components';
import { OrientadorModel } from '../../../Store';
import { media } from '../../../Themes';
import styled from 'styled-components';

interface IDetalhePreProjetoProps {
  orientacao: OrientadorModel,
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const TextAreaGrid = styled(Textarea) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const CardInstrucoes = styled(Card)`
  border: solid 1px #A9A9A9;
`;

const CardTitleInstrucoes = styled(CardTitle)`
  padding-bottom: 5px;
`;

const CardContentInstrucoes = styled(CardContent)`
  padding-top: 5px;
`;

function getSituacaoAluno(sit: string) {
  switch (sit) {
      case "C":
          return "Cadastrado";
      case "F":
          return "Formado";
      case "P":
          return "Promovido";
      case "R":
          return "Retido";
      case "V":
          return "Vago";
      case "T":
          return "Trancado";
      default:
          return "Matriculado"
  }
}

export default function DetalhesPreProjeto(props: IDetalhePreProjetoProps) {
  const { orientacao } = props;

  return (
    <>
      <CardInstrucoes>
        <CardTitleInstrucoes>Instruções:</CardTitleInstrucoes>
        <CardContentInstrucoes>
          Professor, o pré-projeto é apenas uma indicação inicial do interesse do Aluno. O professor poderá, em diálogo como o orientando, 
          auxiliá-lo na modificação, correção e até na mudança de tema. O critério de escolha dos orientandos é de livre decisão do Professor. 
          Não leve em consideração apenas o mérito do pré-projeto, mas também as potencialidades dos estudantes e a necessidade de maior orientação 
          aos alunos que apresentam maiores dificuldades na elaboração de trabalho científico.
        </CardContentInstrucoes>
      </CardInstrucoes>
      <Card>
        <CardTitle>Informações do Pré-Projeto</CardTitle>
        <CardContentGrid>
          <InputGrid
            gridColumn='1/8'
            name='nome'
            label='Nome do Aluno'
            disabled={true}
            value={orientacao.preProjeto.aluno.nome}
          />
          <InputGrid
            gridColumn='8/14'
            name='email'
            label='Email do Aluno'
            disabled={true}
            value={orientacao.preProjeto.aluno.email}
          />
          <InputGrid
            gridColumn='1/8'
            name='serie'
            label='Serie do Aluno'
            disabled={true}
            value={orientacao.preProjeto.aluno.serie}
          />
          <InputGrid
            gridColumn='8/14'
            name='situacao'
            label='Situação do Aluno'
            disabled={true}
            value={getSituacaoAluno(orientacao.preProjeto.aluno.sit)}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='titulo'
            label='Título'
            disabled={true}
            value={orientacao.preProjeto.titulo}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='tema'
            label='Tema'
            disabled={true}
            value={orientacao.preProjeto.tema}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='desenvolvimento'
            label='Desenvolvimento'
            disabled={true}
            value={orientacao.preProjeto.desenvolvimento}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='justificativa'
            label='Justificativa'
            disabled={true}
            value={orientacao.preProjeto.justificativa}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='bibliografia'
            label='Bibliografia'
            disabled={true}
            value={orientacao.preProjeto.bibliografia}
          />
        </CardContentGrid>
      </Card>
    </>
  );
}
